var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1925(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3099 8C16.3099 12.0501 13.0267 15.3333 8.97656 15.3333C4.92647 15.3333 1.64323 12.0501 1.64323 8C1.64323 3.94991 4.92647 0.666667 8.97656 0.666667C13.0267 0.666667 16.3099 3.94991 16.3099 8Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24156 5.70517V13.0002H5.03156C4.45156 13.0002 3.97656 12.5352 3.97656 11.9652V4.54517C3.97656 3.23517 4.95656 2.64017 6.15156 3.22517L8.36656 4.32017C8.84656 4.55517 9.24156 5.18017 9.24156 5.70517Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47719 6.875H5.74219C5.53719 6.875 5.36719 6.705 5.36719 6.5C5.36719 6.295 5.53719 6.125 5.74219 6.125H7.47719C7.68219 6.125 7.85219 6.295 7.85219 6.5C7.85219 6.705 7.68719 6.875 7.47719 6.875Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47719 8.875H5.74219C5.53719 8.875 5.36719 8.705 5.36719 8.5C5.36719 8.295 5.53719 8.125 5.74219 8.125H7.47719C7.68219 8.125 7.85219 8.295 7.85219 8.5C7.85219 8.705 7.68719 8.875 7.47719 8.875Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9922 9.52594V11.7509C13.9922 12.4409 13.4322 13.0009 12.7422 13.0009H9.24219V7.21094L9.47719 7.26094L11.4972 7.71094L11.7372 7.76594L12.7572 7.99594C13.0022 8.04594 13.2272 8.13094 13.4222 8.25594C13.4222 8.26094 13.4272 8.26094 13.4272 8.26094C13.4772 8.29594 13.5272 8.33594 13.5722 8.38094C13.8022 8.61094 13.9522 8.94594 13.9872 9.43594C13.9872 9.46594 13.9922 9.49594 13.9922 9.52594Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1925);
export default __webpack_public_path__ + "static/media/Group 1925.cddf32f15e6e22721c0d0ddbcfbdf52a.svg";
export { ForwardRef as ReactComponent };